import { useState } from 'react';
import { useAlert } from 'react-alert';
import { Link } from 'react-router-dom';
import swal from "sweetalert";
import AttemptQuiz from './AttemptQuiz';
import { MdKeyboardDoubleArrowRight } from 'react-icons/md';

function LessonQuiz({ lessonData, bookData }) {
    console.log(lessonData);
    console.log(bookData);
    const [openModal, setOpenModal] = useState(false);

    const [startTest, setStartTest] = useState(false);
    const [userinput, setuserinput] = useState("")
    const alert = useAlert();


    const hanldeStartQuiz = () => {
        // console.log(lessonData.TestPassword);
        setStartTest(true);

        // if (lessonData.TestPassword) {
        //     setOpenModal(true)
        // } else {
        //     setStartTest(true)
        // }
    }
    const submitPassword = () => {

        if (userinput == lessonData.TestPassword) {
            setOpenModal(false)
            setStartTest(true)
        } else {
            swal("Incorrect Password", "Please Enter Correct Password", { icon: "error" })
        }
        setuserinput('')
    }






    const viewReportJSX = <Link to={`/books/book-lesson-quiz-result`} state={{ lessonData, courseData: bookData }} type="button" className="btn bg-Question-white btn-md ms-md-3 col-md-2" >VIEW REPORT</Link>

    const reAttemptJSX = <button disabled={lessonData.ShowQuizButton==0} to={`/testseries/finalresult`} type="button" className="btn bg-Question-white btn-md ms-md-3 col-md-2" onClick={hanldeStartQuiz}>REATTEMPT</button>

    const continueJSX = <button disabled={lessonData.ShowQuizButton==0} type="button" className="btn bg-Question-white btn-md ms-md-3 col-md-2" onClick={hanldeStartQuiz}>CONTINUE</button>

    const startJSX = <button disabled={lessonData.ShowQuizButton==0} type="button" className="btn bg-Question-white btn-md ms-md-3 col-md-2" onClick={hanldeStartQuiz}>START</button>



    const selectTestStartButtons = () => {
        const allTestsReportsArray = JSON.parse(localStorage.getItem("BookLessonReportArray"));
        const currentTest = allTestsReportsArray?.find((test) => test.sectionId == lessonData?.SectionID);

        if (currentTest) {
            if (lessonData?.Status == 'Complete') {
                return (
                    <>
                        {continueJSX}
                        {viewReportJSX}
                    </>
                )
            } else {
                return (
                    <>
                        {continueJSX}
                    </>

                )
            }

        } else {
            if (lessonData?.Status == 'Complete') {
                if (lessonData?.AttemptCount < lessonData?.TotalAttempt) {
                    return (
                        <>
                            {reAttemptJSX}
                            {viewReportJSX}
                        </>

                    )
                } else {
                    return (
                        <>
                            {viewReportJSX}
                        </>

                    )
                }
            } else {
                return (
                    <>
                        {startJSX}
                    </>

                )
            }
        }

    }

    const getLeesonData = () => {
        if (lessonData?.Status == 'Complete') {
            return { ...lessonData, reAttempt: true }
        } else if (lessonData?.Status != 'Complete') {
            return { ...lessonData, reAttempt: false }
        } else {
            return lessonData;
        }
    }

    return (
        <>
            {!startTest && <div className="d-flex justify-content-between justify-content-md-start gap-2 align-items-baseline flex-wrap">
                <button
                    className={`btn btn-prelims-margin activebuttontabmcq pb-2 pt-2 fs-6 fw-bold`}
                    type="button" >Lesson Quiz MCQs <MdKeyboardDoubleArrowRight size={25} /> </button>
                {
                    selectTestStartButtons()
                }



            </div>}
            {startTest && <><AttemptQuiz lessonData={getLeesonData()} courseData={bookData} /></>}

            {/* <Modal onHide={setOpenModal} show={openModal} size="md" backdrop="static" centered
        keyboard={false} >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" style={{ color: "#ff5722" }} id="exampleModalLabel">Please Enter Quiz Password to proceed</h5>
            <button type="button" className="btn-close" onClick={() => setOpenModal(false)}></button>
          </div>
          <div className="modal-body pt-3">
            <div className="mb-3 ">
              <label htmlFor="inputPassword" style={{ color: "#303972" }} className="form-label">Password<span className="text-danger">*</span></label>
              <input type="text" class="form-control py-1" value={userinput} onChange={(e) => setuserinput(e.target.value)} id="inputPassword" style={{ textTransform: 'none' }} />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-danger btn-xs" onClick={() => setOpenModal(false)}>Close</button>
            <button type="button" className="btn btn-xs text-light" onClick={submitPassword} style={{ backgroundColor: "#303972" }}  >Submit</button>
          </div>
        </div>
      </Modal> */}
        </>
    )
}

export default LessonQuiz;